<script setup lang='ts'>
import { useCommentInputComponent } from './hooks/comment'

const props = withDefaults(defineProps<{
  show?: boolean | null // 是否显示
  autoFocus?: boolean // 是否自动获取焦点
  articleId?: string | null
  commentId?: string | null // 评论文章（null） | 评论评论（number）
  commentName?: string // 评论谁
  option?: { parentIndex?: number; index?: number; isChild?: boolean; toMediaAvatar?: string; toMediaName?: string; toMediaUserId?: string; toCommentId?: string }
}>(), {
  show: null,
  autoFocus: false,
  articleId: null,
  commentId: null,
  commentName: '',
  option: () => ({ isChild: false }),
})
const emits = defineEmits({
  'update:show': (isShow: boolean) => typeof isShow === 'boolean',
  'commentBefore': (content: string) => typeof content === 'string',
  'commentAfter': (data: any) => !!data,
})
const {
  inputRef,
  isLoading,
  commentContent,
  debounceCommentHandle,

  focusHandle,
  blurHandle,
  changeHandle,
} = useCommentInputComponent(props, emits)
</script>

<template>
  <div>
    <n-input
      ref="inputRef"
      v-model:value="commentContent"
      class="bg-gray-100 rounded-md overflow-hidden"
      maxlength="500"
      :autosize="{
        minRows: props.commentId ? 3 : 5,
        maxRows: 8,
      }"
      :autofocus="props.autoFocus"
      show-count type="textarea"
      :placeholder="props.commentId ? `回复${props.commentName ?? ''}...` : '说点什么...'"
      @focus="focusHandle"
      @blur="blurHandle"
      @change="changeHandle"
    />
    <div flex justify-end mt-3>
      <n-button
        class="px-6"
        :loading="isLoading"
        :disabled="!commentContent.length"
        type="primary"
        @click="debounceCommentHandle(props.articleId || '', props.commentId || '')"
      >
        评论
      </n-button>
    </div>
  </div>
</template>
